import React, { createContext, useState, useEffect, useContext } from "react";
import { api } from "./pureFunctions";
import { useAuth } from "./AuthContext";

const ConfigContext = createContext(null);

export function ConfigProvider({ children }) {
   const [config, setConfig] = useState(null);
   const [error, setError] = useState(null);
   const { user, loading } = useAuth();

   useEffect(() => {
      
      if (!user) return;          // kein User -> nichts laden
      if (config) return;         // schon geladen -> nicht erneut
      
         api.get("/api/getConfig")
            .then((data) => {
               console.log(data.data);
               setConfig(data.data);
            })
            .catch((err) => {
               setError(err.message);
            });
      
   }, [user?.id]);

   return (
      <ConfigContext.Provider value={config}>
         {config && children}
      </ConfigContext.Provider>
   );
}

// Custom Hook für einfacheren Zugriff
export const useConfig = () => useContext(ConfigContext);
